var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66732 5.33366V4.66699M6.66732 8.33366V7.66699M6.66732 11.3337V10.667M3.46732 2.66699H12.534C13.2807 2.66699 13.6541 2.66699 13.9393 2.81232C14.1902 2.94015 14.3942 3.14412 14.522 3.395C14.6673 3.68022 14.6673 4.05359 14.6673 4.80033V5.66699C13.3787 5.66699 12.334 6.71166 12.334 8.00033C12.334 9.28899 13.3787 10.3337 14.6673 10.3337V11.2003C14.6673 11.9471 14.6673 12.3204 14.522 12.6056C14.3942 12.8565 14.1902 13.0605 13.9393 13.1883C13.6541 13.3337 13.2807 13.3337 12.534 13.3337H3.46732C2.72058 13.3337 2.34721 13.3337 2.062 13.1883C1.81111 13.0605 1.60714 12.8565 1.47931 12.6056C1.33398 12.3204 1.33398 11.9471 1.33398 11.2003V10.3337C2.62265 10.3337 3.66732 9.28899 3.66732 8.00033C3.66732 6.71166 2.62265 5.66699 1.33398 5.66699V4.80033C1.33398 4.05359 1.33398 3.68022 1.47931 3.395C1.60714 3.14412 1.81111 2.94015 2.062 2.81232C2.34721 2.66699 2.72058 2.66699 3.46732 2.66699Z",
    stroke: "#1b1d52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket01);
export default __webpack_public_path__ + "static/media/ticket-01.1a1170a4c7388b6328583607982c18f2.svg";
export { ForwardRef as ReactComponent };